<template>
  <div>
    <el-form :model="ruleForm" class="formEdit" ref="formEdit" :rules="rules" label-width="100px">
      <el-form-item label="s2sKey" title="s2sKey" prop="s2sKey">
        <el-input v-model="ruleForm.s2sKey" :placeholder="$t('placeholder.datainput')" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="scipUUid" title="scipUUid" prop="scipUuid">
        <el-input v-model="ruleForm.scipUuid" :placeholder="$t('placeholder.datainput')" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="userName" title="userName" prop="userName">
        <el-input v-model="ruleForm.userName" :placeholder="$t('placeholder.datainput')" size="mini"></el-input>
      </el-form-item>
    </el-form>
    <div style="text-align: right">
      <!--<el-button @click="cancleCommit" size="mini">取 消</el-button>-->
      <el-button type="primary" @click="commitButton" size="mini">确 定</el-button>
    </div>
  </div>
</template>

<script>
import { scipUserinfo, getScipUserInfo, putScipUserinfo } from "@/api/user";
import JSEncrypt from "../../utils/jsencrypt.min.js";

export default {
  name: "",
  components: {},
  props: ['type'],
  data() {
    return {
      ruleForm: {},
      rules: {
        s2sKey: [
          { required: true, message: this.$t('placeholder.nullcheck'), trigger: 'blur' }
        ],
        scipUuid: [
          { required: true, message: this.$t('placeholder.nullcheck'), trigger: 'blur' }
        ],
        userName: [
          { required: true, message: this.$t('placeholder.nullcheck'), trigger: 'blur' }
        ]
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getScipUserInfo();
  },
  mounted() {
  },
  methods: {
    getScipUserInfo() {
      getScipUserInfo(['查询scip账号']).then((res) => {
        if(res.data){
          this.ruleForm = res.data;
        }
      })
    },
    commitButton() {
      this.$refs.formEdit.validate(valid => {
        if (valid) {
          //id存在调用修改，否则调用新增
          if (this.ruleForm.id) {
            putScipUserinfo(this.ruleForm, ['绑定scip账号']).then(res => {
              this.$message.success('修改绑定成功');
              this.$emit('closePwdVisible', '');
            })
          } else {
            let option = {
              s2sKey: this.ruleForm.s2sKey,
              scipUuid: this.ruleForm.scipUuid,
              userName: this.ruleForm.userName
            }
            scipUserinfo(option, ['绑定scip账号']).then(res => {
              this.$message.success('绑定成功');
              this.$emit('closePwdVisible', '');
            })
          }

        }
      });

    },
    cancleCommit() {
      this.$emit('closePwdVisible', '');
    },
  },
};
</script>

<style scoped lang="scss">
.sechstandard {
  margin-left: -10px;
  margin-right: -10px;
  padding: 0 10px 15px;
  @include font-color("color");
  line-height: 22px;
}
</style>
